// extracted by mini-css-extract-plugin
export default {"careerBox":"Career__careerBox-XFOR","title":"Career__title-Y0VO","description":"Career__description-d80H"};